// extracted by mini-css-extract-plugin
module.exports = {"nolist":"producthome_nolist_2V1z-","img2":"producthome_img2_IB87q","root":"producthome_root_3mvfP"};